module.exports = __webpack_public_path__ + "img/login-logo.e9a94b7d.svg";